module.exports = __webpack_public_path__ + "img/logistic-1.fb43fa6f.png";